import "core-js/modules/es.array.push.js";
import { createNamespacedHelpers } from "vuex";
const gameVuex = createNamespacedHelpers("game");
export default {
  name: "mMenu",
  computed: {
    ...gameVuex.mapState(["gameProgress", "gameData", "upgradeResultInfo"])
  },
  data() {
    const menuList = [{
      label: "Rewards",
      value: "rewards"
    }, {
      label: "Lucky",
      value: "lucky"
    }, {
      label: "Human",
      value: "human"
    }, {
      label: "Upgrade",
      value: "upgrade"
    }, {
      label: "Friends",
      value: "friends"
    }];
    return {
      menuList,
      selectMenu: null
    };
  },
  watch: {
    "$route.path": {
      handler(path) {
        if (path === "/") {
          return this.selectMenu = "human";
        }
        this.selectMenu = path.split("/")[1];
      },
      deep: true,
      immediate: true
    }
  },
  methods: {
    onMenu(item) {
      this.hapticFeedback();
      if (item.value === "human") {
        this.selectMenu = "human";
        this.$router.push(`/`);
        return;
      }
      this.selectMenu = item.value;
      this.$router.push(`/${item.value}`);
    }
  }
};